//app/signin/page.tsx
"use client";
import { useState, useEffect } from "react";
import Image from "next/image";
import { Link } from "@/i18n/navigation";
import OtpVerify from "@/components/auth/OtpVerify";
import { apiLogin, apiVerifyOtp, AuthApiError } from "@/lib/auth-api";
import { collectFingerprint } from "@/lib/fingerprint";
//import { getAccessToken } from "@/lib/auth";
import { setAccessToken, saveRememberMe } from "@/lib/auth";
import { useAuth } from "@/components/auth/auth-context";
import { useChatStore } from "@/store/chatStore";
import { useTranslations } from "next-intl";
import { useRouter } from "@/i18n/navigation";
import HexLive from "@/components/HexLive";
import { env } from "@/lib/env";

// Возврат после логина: только на /chat*, защита от open redirect
function chatTarget(): string {
  if (typeof window === "undefined") return "/chat";
  const next = new URLSearchParams(window.location.search).get("next");
  return next && next.startsWith("/chat") && !next.startsWith("//") ? next : "/chat";
}


type Step = "credentials" | "otp" | "success";

export default function SignInPage() {
  const router = useRouter();
  const [step, setStep] = useState<Step>("credentials");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [username, setUsername] = useState(""); // Назовем "username", боты его обожают
  //const [rememberMe, setRememberMe] = useState(false);
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState<Record<string, string>>({});
  const [otpError, setOtpError] = useState("");
  const { isAuthenticated, isLoading, user} = useAuth();
  const [showPassword, setShowPassword] = useState(false);
  const { refreshUser } = useAuth();
  const {isLoading: authLoading, logout } = useAuth();
  const t = useTranslations("signin");
  const tc = useTranslations("common");
  
  useEffect(() => {
      const onPageShow = (e: PageTransitionEvent) => {
        if (e.persisted) window.location.reload();
      };
      window.addEventListener('pageshow', onPageShow);
      return () => window.removeEventListener('pageshow', onPageShow);
    }, []);

  
  const validate = () => {
    const e: Record<string, string> = {};
    if (!email) e.email = t("errors.emailRequired");
    else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) e.email = t("errors.emailInvalid");
    if (!password) e.password = t("errors.passwordRequired");
    else if (password.length < 6) e.password = t("errors.passwordMin");
    setErrors(e);
    return Object.keys(e).length === 0;
  };

    
  //const handleLogin = async () => {
  //  if (!validate()) return;
  //  setLoading(true);
  //  setErrors({});
  //  try {
   //   const fp = await collectFingerprint();
      // На бэке сейчас сразу возвращает токены (без OTP)
      // Когда OTP будет готов — бэк вернёт { message: 'OTP sent' } и переходим на шаг otp
   //   const res = await apiLogin({ email, password, rememberMe, fingerprintHash: fp.hash });
      //const res = await apiLogin({ email, password, rememberMe});

        // ДОБАВЬ ЭТОТ ЛОГ: - Новый метод!!!!!!!!!!!
    //      console.log("DEBUG LOGIN RESPONSE:", res);

          //if (res.accessToken && res.refreshToken) { // Проверяем ОБА токена
           //   saveTokens({ 
            //      accessToken: res.accessToken, 
            //      refreshToken: res.refreshToken || "",  // ДЛЯ ТЕСТОВ!!!!
            //      rememberMe 
            //  });
            //  router.push("/chat");
         // } else {
          //    console.error("Ошибка: Бэк не вернул один из токенов!", res);
              // Возможно, нужно setStep("otp"), если бэк ждет код
         // }

  // ------------------ Конец --------------

  const handleLogin = async () => {
    if (username) { 
    console.warn("Bot detected");
    // Имитируем успех или просто молча выходим, чтобы бот не понял подвоха
    //router.push("/chat"); 
    window.location.assign(window.location.origin + chatTarget());
    return; 
      }
  if (!validate()) return;
  setLoading(true);
  setErrors({});
  try {
    console.log("[SignIn] attempting login for:", email)
    const fp = await collectFingerprint();
    //const res = await apiLogin({ email, password, rememberMe, fingerprintHash: fp.hash });
    const res = await apiLogin({ email, password, fingerprintHash: fp.hash });
    console.log("[SignIn] login success, accessToken:", res.accessToken ? "EXISTS" : "NULL")
    // Бэк вернул только accessToken — refreshToken уже в httpOnly cookie
    
    setAccessToken(res.accessToken);
    //saveRememberMe(rememberMe);
    useChatStore.getState().setActiveChat(null);
    useChatStore.setState({ activeChatSessionId: null, sessions: [] });
    await refreshUser();
    console.log("[SignIn] token saved, pushing to /chat")
    // TODO: когда бэк добавит OTP — убрать router.push и раскомментить setStep("otp")
    // TODO: когда бэк добавит OTP — убрать строки ниже и раскомментить setStep("otp")
      // setStep("otp");
      //router.push("/chat");
    window.location.assign(window.location.origin + chatTarget());
  } catch (err) {
    console.error("[SignIn] login error:", err)
    if (err instanceof AuthApiError) {
      if (err.status === 401) setErrors({ password: t("errors.invalidCredentials") });
      else if (err.status === 403) setErrors({ email: t("errors.accountBlocked") });
      else setErrors({ general: err.message });
      } else {
      setErrors({ general: t("errors.network") });
    }
  } finally {
    setLoading(false);
  }
};

  const handleVerifyOtp = async (code: string) => {
    setOtpError("");
    try {
      const res = await apiVerifyOtp({ email, code });
      console.log("ПОЛНЫЙ ОТВЕТ БЭКА:", res); 
        // Посмотри в консоль браузера. Если там нет поля refreshToken, 
        // значит бэкенд его не отдал.
        setAccessToken(res.accessToken);
        saveRememberMe(false);
        useChatStore.getState().setActiveChat(null);
        useChatStore.setState({ activeChatSessionId: null }); 
        // при регистрации rememberMe всегда false
      //saveTokens({ accessToken: res.accessToken, refreshToken: res.refreshToken, rememberMe });
      //router.push("/chat");
    } catch (err) {
      if (err instanceof AuthApiError) {
        if (err.status === 410) setOtpError(t("errors.otpExpired"));
        else if (err.status === 429) setOtpError(t("errors.otpRateLimit"));
        else setOtpError(t("errors.otpInvalid"));
      }
    }
  };

  const handleResendOtp = async () => {
   // await apiLogin({ email, password, rememberMe });
    await apiLogin({ email, password });
  };
  if (authLoading) {
      return (
        <div className="h-screen flex items-center justify-center">
          <div className="relative w-20 h-20">
            <div className="absolute inset-0 rounded-full border-4 border-transparent border-t-[#0f199c] border-b-[#0f199c] animate-[spin_1.2s_linear_infinite]" />
            <div className="absolute inset-[10px] rounded-full border-4 border-transparent border-t-[#475fab] border-b-[#475fab] animate-[spin_1.8s_linear_infinite_reverse]" />
            <div className="absolute inset-[20px] rounded-full border-4 border-transparent border-t-[#7f84cb] border-b-[#7f84cb] animate-[spin_1s_linear_infinite]" />
          </div>
        </div>
      );
    }
  useEffect(() => {
    if (!authLoading && isAuthenticated) {
      window.location.replace(window.location.origin + chatTarget());
    }
  }, [authLoading, isAuthenticated, router]);

  if (!authLoading && isAuthenticated) {
    return (
      <div className="h-screen flex flex-col items-center justify-center gap-4">
        <div className="relative w-20 h-20">
            <div className="absolute inset-0 rounded-full border-4 border-transparent border-t-[#0f199c] border-b-[#0f199c] animate-[spin_1.2s_linear_infinite]" />
            <div className="absolute inset-[10px] rounded-full border-4 border-transparent border-t-[#475fab] border-b-[#475fab] animate-[spin_1.8s_linear_infinite_reverse]" />
            <div className="absolute inset-[20px] rounded-full border-4 border-transparent border-t-[#7f84cb] border-b-[#7f84cb] animate-[spin_1s_linear_infinite]" />
          </div>
        <p className="text-sm text-zinc-500">{t("redirecting")}</p>
      </div>
    );
  }

  return (
    <div className="h-screen flex overflow-hidden bg-white">
      {/* ── Left: Form ── */}
      <div className="flex-1 h-full flex flex-col px-6 py-4 lg:px-16 lg:py-8 overflow-y-auto custom-scrollbar">
        {/* Logo */}
        <div className="flex items-center justify-between mb-4 lg:mb-10">
          <Link href="/" className="text-lg font-semibold tracking-widest text-zinc-900 uppercase">
           {tc("brand")}
          </Link>
          
        </div>

        {/* Form area */}
        <div className="flex-1 flex items-center justify-center py-2 lg:py-6">
          <div className="w-full max-w-sm my-auto space-y-1">
            {step === "credentials" && (
              <form onSubmit={(e) => { e.preventDefault(); handleLogin(); }} noValidate>
                <h1 className="text-xl lg:text-2xl font-semibold text-zinc-900 tracking-tight mb-1">
                    {t("title")}
                  </h1>
                  <p className="text-sm text-zinc-500 mb-4 lg:mb-6">
                 {t("noAccount")}{" "}
                  <Link href="/signup" className="text-zinc-900 font-medium underline underline-offset-2 hover:no-underline">
                    {t("signup")}
                  </Link>
                </p>

                {/* OAuth */}
                <div className="space-y-2 mb-4">
                  {/*<button
                    disabled
                    className="w-full flex items-center justify-center gap-3 py-2 px-4 rounded-xl bg-zinc-900 text-white text-sm font-medium hover:bg-zinc-700 transition-colors disabled:opacity-40 disabled:cursor-not-allowed"
                  >
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-4.714-6.231-5.401 6.231H2.744l7.73-8.835L1.254 2.25H8.08l4.259 5.622zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
                    </svg>
                    Войти через X
                    <span className="ms-auto text-xs text-zinc-500 font-normal">скоро</span>
                  </button> */}

                  <button
                      type="button"
                        onClick={() => { sessionStorage.removeItem("oauth_callback_processed"); sessionStorage.setItem("postLoginNext", chatTarget()); window.location.href = `${env.apiUrl}/auth/google`; }}
                      className="w-full flex items-center justify-center gap-3 py-2.5 px-4 rounded-xl border border-zinc-200 text-zinc-700 text-sm font-medium hover:border-zinc-400 hover:bg-zinc-50 transition-all"
                    >
                    <svg width="16" height="16" viewBox="0 0 24 24">
                      <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4"/>
                      <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/>
                      <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05"/>
                      <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/>
                    </svg>
                    {t("googleBtn")}
                    {/* <span className="ms-auto text-xs text-zinc-400 font-normal">скоро</span> */}
                  </button>
                </div>

                {/* Divider */}
                <div className="flex items-center gap-3 mb-4">
                  <div className="flex-1 h-px bg-zinc-100" />
                  <span className="text-xs text-zinc-400">{t("orEmail")}</span>
                  <div className="flex-1 h-px bg-zinc-100" />
                </div>

                {/* General error */}
                {errors.general && (
                  <div className="mb-4 p-3 rounded-xl bg-red-50 border border-red-100 text-sm text-red-600 flex items-center gap-2">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <circle cx="12" cy="12" r="10"/><path d="M12 8v4m0 4h.01"/>
                    </svg>
                    {errors.general}
                  </div>
                )}

                {/* Email - input = onKeyDown={(e) => e.key === "Enter" && handleLogin()}*/}
                <div className="mb-3">
                  <label className="block text-xs font-medium text-zinc-600 mb-1.5">{t("emailLabel")}</label>
                  <input
                    type="email"
                    autoComplete="off"
                    value={email}
                    onChange={(e) => { setEmail(e.target.value); setErrors((p) => ({ ...p, email: "" })); }}
                    
                    placeholder="you@example.com"
                    className={`w-full px-4 py-2 rounded-xl border text-sm outline-none transition-all
                      ${errors.email ? "border-red-300 bg-red-50 focus:ring-red-200" : "border-zinc-200 focus:border-zinc-900 focus:ring-zinc-900/10"}
                      focus:ring-2`}
                  />
                  {errors.email && <p className="text-xs text-red-500 mt-1">{errors.email}</p>}
                </div>

                {/* Password = onKeyDown={(e) => e.key === "Enter" && handleLogin()}*/}
                {/* Password */}
                  <div className="mb-3">
                    <div className="flex items-center justify-between mb-1.5">
                      <label className="text-xs font-medium text-zinc-600">{t("passwordLabel")}</label>
                      <Link href="/forgot-password" className="text-xs text-zinc-400 hover:text-zinc-700 transition-colors">
                       {t("forgotPassword")}
                      </Link>
                    </div>
                    <div className="relative">
                      <input
                        type={showPassword ? "text" : "password"}
                        autoComplete="new-password"
                        value={password}
                        onChange={(e) => { setPassword(e.target.value); setErrors((p) => ({ ...p, password: "" })); }}
                        placeholder="••••••••"
                        className={`w-full px-4 py-2 pe-10 rounded-xl border text-sm outline-none transition-all
                          ${errors.password ? "border-red-300 bg-red-50 focus:ring-red-200" : "border-zinc-200 focus:border-zinc-900 focus:ring-zinc-900/10"}
                          focus:ring-2`}
                      />

                      {/* HONEYPOT -  поле для бтв */}
                        <div className="absolute opacity-0 -z-10 h-0 w-0 overflow-hidden" aria-hidden="true">
                          <input
                            type="text"
                            name="username"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                            tabIndex={-1}
                            autoComplete="off"
                          />
                        </div>
                      <button
                        type="button"
                        onClick={() => setShowPassword(!showPassword)}
                        className="absolute end-3 top-1/2 -translate-y-1/2 text-zinc-400 hover:text-zinc-600 transition-colors"
                      >
                        {showPassword ? (
                          <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"/>
                            <line x1="1" y1="1" x2="23" y2="23"/>
                          </svg>
                        ) : (
                          <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
                            <circle cx="12" cy="12" r="3"/>
                          </svg>
                        )}
                      </button>
                    </div>
                    {errors.password && <p className="text-xs text-red-500 mt-1">{errors.password}</p>}
                  </div>

                {/* Remember me */}
                {/* Скрытый инпут ловит клик по всей площади label */}
                {/*<label className="flex items-center gap-2.5 mb-4 cursor-pointer group">
                      
                      <input 
                        type="checkbox" 
                        className="sr-only" 
                        checked={rememberMe}
                        onChange={() => setRememberMe(!rememberMe)} 
                      />
                      */}
                      {/* Визуальный квадратик */}
                     {/* <div className={`w-4 h-4 rounded flex items-center justify-center border transition-all
                        ${rememberMe ? "bg-zinc-900 border-zinc-900" : "border-zinc-300 group-hover:border-zinc-500"}`}
                      >
                        {rememberMe && (
                          <svg width="10" height="10" viewBox="0 0 12 12" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <polyline points="2 6 5 9 10 3"/>
                          </svg>
                        )}
                      </div>
                      
                      <span className="text-xs text-zinc-600 select-none">
                        Запомнить меня на 30 дней
                      </span>
                    </label>*/}

                {/* Submit = onClick={handleLogin}*/}
                <button
                  type="submit"
                  
                  disabled={loading}
                  className="w-full py-2 bg-zinc-900 text-white text-sm font-medium rounded-xl hover:bg-zinc-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2"
                >
                  {loading ? (
                    <>
                      <div className="w-4 h-4 border-2 border-white/30 border-t-white rounded-full animate-spin" />
                      {t("submitting")}
                    </>
                  ) : t("submit")}
                </button>

                {/* ToS */}
                <p className="text-xs text-zinc-400 text-center mt-5 leading-relaxed">
                  {t("tosText")}{" "}
                  <Link href="/terms" className="underline underline-offset-2 hover:text-zinc-700">{t("tosLink")}</Link>
                  {" "}{t("andText")}{" "}
                  <Link href="/privacy" className="underline underline-offset-2 hover:text-zinc-700">{t("privacyLink")}</Link>
                </p>
              </form>
            )}

            {step === "otp" && (
              <OtpVerify
                email={email}
                onVerify={handleVerifyOtp}
                onResend={handleResendOtp}
                onBack={() => setStep("credentials")}
                error={otpError}
                loading={loading}
              />
            )}
          </div>
        </div>
      </div>

      {/* ── Right: Illustration ── */}
      {/* ── Right: Illustration (same as signin) ── */}
      {/* ── Right: Illustration ── */}
      {/*
      <div className="hidden lg:flex flex-1 bg-[#0d1b35] items-center justify-center relative overflow-hidden h-screen sticky top-0">
        -- Fallback фон — звёзды, если картинка не загрузится ---
        {[...Array(18)].map((_, i) => (
          <div
            key={i}
            className="absolute pointer-events-none"
            style={{
              left: `${Math.floor(10 + (i * 37) % 80)}%`,
              top: `${Math.floor(5 + (i * 53) % 45)}%`,
              opacity: 0.3 + (i % 4) * 0.12,
            }}
          >
            <svg width={i % 3 === 0 ? 14 : 8} height={i % 3 === 0 ? 14 : 8} viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
              <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>
            </svg>
          </div>
        ))}

        ---Картинка с предметами ---
        <div className="relative w-full max-w-[480px] aspect-square mb-16">
          <Image
              src="/illustrations/subjects-network.png"
              alt="Subjects network"
              fill
              className="object-contain"
              onError={(e) => { (e.currentTarget as HTMLImageElement).style.display = 'none'; }}
              priority={false}
            />

          --- Локализованные подписи поверх картинки ---
          --Координаты в % — настраиваются под исходник ---
          <span className="absolute left-[15%]  top-[27%] text-[11px] font-semibold tracking-wider text-cyan-300/90 uppercase">{t("math")}</span>
          <span className="absolute right-[27%] top-[27%] text-[11px] font-semibold tracking-wider text-emerald-300/90 uppercase">{t("chemistry")}</span>
          <span className="absolute left-[6%]   top-[57%] text-[11px] font-semibold tracking-wider text-rose-300/90 uppercase">{t("medicine")}</span>
          <span className="absolute right-[18%]  top-[57%] text-[11px] font-semibold tracking-wider text-purple-300/90 uppercase">{t("psychology")}</span>
          <span className="absolute left-[16%]  top-[81%] text-[11px] font-semibold tracking-wider text-amber-200/90 uppercase">{t("history")}</span>
          <span className="absolute right-[30%] top-[81%] text-[11px] font-semibold tracking-wider text-teal-300/90 uppercase">{t("biology")}</span>
        </div>

        -- Tagline снизу ---
        <div className="absolute bottom-6 left-0 right-0 text-center px-8">
          <p className="text-white/90 text-sm font-medium tracking-wide">
            {t("tagline")}
          </p>
        </div>
      </div> */}
        {/* ── Right: Illustration ── */}
          <div className="hidden lg:flex flex-1 bg-zinc-50 items-center justify-center relative overflow-hidden h-screen sticky top-0">
            
          <Image
              src="/illustrations/subjects-network.png"
              alt="Subjects network"
              fill
              className="object-contain"
              onError={(e) => { (e.currentTarget as HTMLImageElement).style.display = 'none'; }}
              priority={false}
            />
            
            {/* Hexagon decorations */}
            <HexLive className="absolute right-[8%]  top-24      w-20 h-20" mode="pulse" baseOpacity={0.15} intervalSec={42} />
            <HexLive className="absolute right-[15%] bottom-12   w-32 h-32" mode="pulse" baseOpacity={0.10} intervalSec={55} />
            <HexLive className="absolute right-[5%]  bottom-32   w-12 h-12" mode="spark" baseOpacity={0.20} intervalSec={32} />
            <HexLive className="absolute left-[3%]  bottom-20   w-16 h-16" mode="spark" baseOpacity={0.12} intervalSec={38} />
            <HexLive className="absolute left-[10%] top-16       w-24 h-24" mode="pulse" baseOpacity={0.08} intervalSec={60} />
            <HexLive className="absolute left-[20%] top-[45%]    w-10 h-10" mode="spark" baseOpacity={0.18} intervalSec={28} />

              

            {/* Tagline снизу */}
           {/* <div className="absolute bottom-6 left-0 right-0 text-center px-8">
              <p className="text-zinc-400 text-sm font-medium tracking-wide">
                {t("tagline")}
              </p>
            </div> */}
          </div>

      </div>
  );
}